import {apiUrl} from 'apiConstants';
import axios from 'axios';

const format = require("string-format");


format.extend(String.prototype, {});

const actions = {
    GetAllTimeZonesSuccess: (payload) => ({
        type: "FETCH_ALL_TIMEZONES_SUCCESS",
        payload
    }),
    GetAllTimeZonesError: (payload) => ({
        type: "FETCH_ALL_TIMEZONES_ERROR",
        payload
    })
};

export const fetchAllTimeZones = () => (dispatch, getState) => {
    const state = getState();
    if (state.timeZones) {
        if (state.timeZones.list) {
            if (state.timeZones.list.length > 0) {
                return Promise.resolve(true);
            }
        }
    }
    const url = apiUrl.BASE_URL + apiUrl.GET_ALL_TIMEZONES;

    return axios
        .get(url)
        .then(response => {
            if (response.status === 200) {
                const timeZoneList = {};
                response.data.data.map((data) => {
                    timeZoneList[data.id] = data;
                });

                dispatch(actions.GetAllTimeZonesSuccess(timeZoneList));
                return response;

            }
            dispatch(actions.GetAllTimeZonesError(response.message));
            return response;

        })
        .catch(error => {
            dispatch(actions.GetAllTimeZonesError(error.message));
            return Promise.resolve(error);
        });
};
